import React, { useState } from 'react';
import Loading from '../components/Loading';
import { getNakshatraReading, isGeminiReady } from '../services/geminiService';
import { useLanguage } from '../context/LanguageContext';
import { NAKSHATRAS } from '../data/astroData';

export default function Nakshatra() {
  const { language, t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    dateOfBirth: '',
    timeOfBirth: '',
    placeOfBirth: '',
  });
  const [reading, setReading] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleGetReading = async () => {
    if (!formData.dateOfBirth) {
      setError(t('fillDateOfBirth'));
      return;
    }
    if (!isGeminiReady()) {
      setError(t('apiKeyError'));
      return;
    }
    setLoading(true);
    setError('');
    setReading('');
    try {
      const result = await getNakshatraReading(
        formData.name,
        formData.dateOfBirth,
        formData.timeOfBirth,
        formData.placeOfBirth,
        language
      );
      setReading(result);
    } catch (err) {
      setError(err.message || 'Failed to get nakshatra reading.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="container">
        <div className="page-header">
          <h2>{t('nakshatraTitle')}</h2>
          <p>{t('nakshatraDesc')}</p>
        </div>

        {/* 27 Nakshatras Display */}
        <div className="nakshatra-wheel">
          <h3>{t('the27Nakshatras')}</h3>
          <div className="nakshatra-grid">
            {NAKSHATRAS.map((nak, index) => (
              <div key={nak.name} className="nakshatra-card">
                <span className="nakshatra-symbol">{nak.symbol}</span>
                <span className="nakshatra-name">{nak.name}</span>
                <span className="nakshatra-deity">{nak.deity}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Form */}
        <div className="form-section">
          <h3>{t('findYourNakshatra')}</h3>
          <div className="form-grid">
            <div className="form-group">
              <label>{t('fullName')}</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder={t('enterFullName')}
              />
            </div>
            <div className="form-group">
              <label>{t('dateOfBirth')} *</label>
              <input
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>{t('timeOfBirth')}</label>
              <input
                type="time"
                name="timeOfBirth"
                value={formData.timeOfBirth}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label>{t('placeOfBirth')}</label>
              <input
                type="text"
                name="placeOfBirth"
                value={formData.placeOfBirth}
                onChange={handleInputChange}
                placeholder={t('cityCountry')}
              />
            </div>
          </div>
        </div>

        {/* Get Reading Button */}
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <button className="btn btn-primary" onClick={handleGetReading} disabled={loading}>
            {loading ? t('calculatingNakshatra') : t('findMyNakshatra')}
          </button>
        </div>

        {loading && <Loading message={t('loadingNakshatra')} />}
        {error && <div className="error-message">{error}</div>}

        {reading && (
          <div className="result-container">
            <div className="result-card">
              <h3>⭐ {t('nakshatraResult')}</h3>
              <div className="content">{reading}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
